import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from './button';
import { TipsModal } from './TipsModal';
import { getVentaData, setVentaData, clearVentaData } from '../../utils/ventaTemp';
import { enviarVentaYPropina } from '../../services/api';
import API_BASE_URL from '../../Config';


export default function MixedPaymentModal({ onClose, onPaymentSuccess }) {
  const venta = getVentaData();
  const productosOriginales = venta?.productos || [];
  const productos = productosOriginales.map(p => ({
    id: p.id || p.productId,
    nombre: p.nombre || p.productName || p.name,
    precio: p.precio || p.price,
    cantidad: p.cantidad || 1
  }));
  const total = venta?.total || 0;
  

  const [showPropinaPregunta, setShowPropinaPregunta] = useState(false);
  const [showTipsModal, setShowTipsModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [cashAmount, setCashAmount] = useState(0);
  const [cardAmount, setCardAmount] = useState(0);
  const tarjeta = parseFloat(cardAmount) || 0;
  const faltante = total - tarjeta;

  const [tarjetaProcesada, setTarjetaProcesada] = useState(false);
  const [showTarjetaAprobada, setShowTarjetaAprobada] = useState(false);
  const [clientCI, setClientCI] = useState('');
  const [clientInfo, setClientInfo] = useState(null);
  const [nombre, setNombre] = useState('');
  const [apellido, setApellido] = useState('');
  const [error, setError] = useState('');
  const [invoiceOption, setInvoiceOption] = useState('no');
  const [showClientForm, setShowClientForm] = useState(false);
  const clienteRef = useRef(null);
  const navigate = useNavigate();

  const buscarCliente = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/register-process/buscar/${clientCI}`);
      if (res.ok) {
        const data = await res.json();
        setClientInfo(data);
        clienteRef.current = data;
        setShowClientForm(false);
      } else {
        setClientInfo(null);
        setShowClientForm(true);
      }
    } catch (error) {
      console.error('Error al buscar cliente:', error);
    }
  };

  const registrarCliente = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/register-process`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nombre: `${nombre} ${apellido}`,
          ci: clientCI,
          digitoVerificador: 0,
        }),
      });

      if (res.ok) {
        setClientInfo({ nombre: `${nombre} ${apellido}`, ci: clientCI, digitoVerificador: '0' });
        clienteRef.current = { nombre: `${nombre} ${apellido}`, ci: clientCI, digitoVerificador: '0' };
        setShowClientForm(false);
        alert('✅ Cliente registrado correctamente');
      } else {
        alert('❌ No se pudo registrar el cliente');
      }
    } catch (err) {
      console.error('Error al registrar cliente:', err);
    }
  };

  const handleConfirm = () => {
    const tarjeta = parseFloat(cardAmount);
    const efectivo = parseFloat(cashAmount);
    const totalIngresado = tarjeta + efectivo;
    const faltante = total - tarjeta;

    if (isNaN(efectivo) || efectivo <= 0) {
      setError('Ingrese un monto válido para efectivo.');
      return;
    }

    if (totalIngresado < total) {
      setError('La suma es menor al total. Complete el monto restante.');
      return;
    }

    if (totalIngresado > total) {
      setError('La suma ingresada excede el total. Verifique los montos.');
      return;
    }

    if (efectivo !== faltante) {
      setError(`El monto en efectivo debe ser exactamente ${faltante.toFixed(2)}.`);
      return;
    }

    setError('');
    //esto se hizo para que no muestre mas la pregunta de dejar mozo, se va directo a omitir propina  
    handleOmitirPropina();
    //setShowPropinaPregunta(true);
  };


  //jaaja

  const handleConfirmPropina = () => {
    const fechaActual = new Date().toISOString();
    const cliente = invoiceOption === 'no'
      ? { nombre: 'Cliente sin Nombre', ci: '0', digitoVerificador: '0' }
      : clienteRef.current;

    const currentVenta = getVentaData();
    const totalRecalculado = productos.reduce((sum, p) => sum + (p.precio * p.cantidad), 0);

    const ventaData = {
      ...currentVenta,
      fecha: fechaActual,
      metodoPago: 'MIXTO',
      efectivo: parseFloat(cashAmount),
      tarjeta: parseFloat(cardAmount),
      total: totalRecalculado,
      productos,
      cliente,
      registerProcess: cliente.ci
    };

    setVentaData(ventaData);
    setShowTipsModal(true);
  };

  const handleOmitirPropina = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    const fechaActual = new Date().toISOString();
    const cliente = invoiceOption === 'no'
      ? { nombre: 'Cliente sin Nombre', ci: '0', digitoVerificador: '0' }
      : clienteRef.current;

    const currentVenta = getVentaData();
    const totalRecalculado = productos.reduce((sum, p) => sum + (p.precio * p.cantidad), 0);

    const ventaData = {
      ...currentVenta,
      fecha: fechaActual,
      metodoPago: 'MIXTO',
      efectivo: parseFloat(cashAmount),
      tarjeta: parseFloat(cardAmount),
      total: totalRecalculado,
      productos,
      cliente,
      registerProcess: cliente.ci
    };

    setVentaData(ventaData);

try {
  const response = await enviarVentaYPropina(ventaData);
  const ventaId = response?.id;
if (ventaId) {
  onPaymentSuccess({ deseaDejarPropina: false, ventaId });
  clearVentaData();
} else {
    console.error('❌ La venta fue enviada pero no se recibió el ID');
  }
} catch (error) {
  console.error('❌ Error al guardar venta sin propina:', error);
}
  };

const handleTipsConfirm = async ({ tip, mozo }) => {
  if (isSubmitting) return;
  setIsSubmitting(true);

  const propina = parseFloat(tip || 0);
  const ventaActual = getVentaData();
  const totalConPropina = (ventaActual.total || 0) + propina;

  const ventaFinal = {
    ...ventaActual,
    propina,
    mozo,
    total: totalConPropina,
    productos
  };

  setVentaData(ventaFinal);

  try {
    const response = await enviarVentaYPropina(ventaFinal);
    const ventaId = response?.id;
if (ventaId) {
  onPaymentSuccess({ deseaDejarPropina: true, ventaId });
  setShowTipsModal(false);
  clearVentaData();
}
 else {
      console.error('❌ La venta fue enviada pero no se recibió el ID');
    }
  } catch (error) {
    console.error('❌ Error al guardar venta con propina:', error);
  } finally {
    setIsSubmitting(false);
  }
};


  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black/50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-md">
        <h2 className="text-lg font-bold mb-4">Pago Mixto</h2>
        <p className="mb-3 text-sm text-gray-600">
          Total a pagar: <strong>${total.toFixed(2)}</strong>
        </p>

        <div className="mb-3">
          <label>Tarjeta:</label>
          <input
            type="number"
            className="w-full border px-3 py-1"
            value={cardAmount}
            onChange={(e) => setCardAmount(e.target.value)}
            disabled={tarjetaProcesada}
          />
          {!tarjetaProcesada && (
            <Button
              className="mt-2 w-full"
              onClick={() => {
                const tarjeta = parseFloat(cardAmount);

                if (isNaN(tarjeta) || tarjeta <= 0) {
                  alert('Ingrese un monto válido para tarjeta');
                  return;
                }

                if (tarjeta >= total) {
                  alert('⚠️ El monto con tarjeta cubre o excede el total. Use solo un método de pago o reduzca el monto.');
                  return;
                }

                setTarjetaProcesada(true);
                setShowTarjetaAprobada(true);
                setTimeout(() => setShowTarjetaAprobada(false), 3000);
              }}
            >
              Cobrar tarjeta
            </Button>


            //jajajaaj
          )}
          {showTarjetaAprobada && (
            <p className="text-green-600 text-center mt-2">✅ Pago con tarjeta aprobado</p>
          )}
        </div>

        <div className="mb-3">
          <label>Efectivo:</label>
          <input
            type="number"
            className="w-full border px-3 py-1"
            value={cashAmount}
            onChange={(e) => setCashAmount(e.target.value)}
            disabled={!tarjetaProcesada}
          />
          {tarjetaProcesada && (
            <p className="text-sm text-gray-600 mt-1">
              Monto restante a cubrir: <strong>${faltante.toFixed(2)}</strong>
            </p>
          )}
        </div>


        {/*JAJAJ */}

        <div className="mt-4">
          <p className="font-medium mb-2">¿Desea factura?</p>
          <div className="flex gap-4">
            <label className="flex items-center gap-1 text-sm">
              <input
                type="radio"
                value="yes"
                checked={invoiceOption === 'yes'}
                onChange={() => setInvoiceOption('yes')}
              />
              Con factura
            </label>
            <label className="flex items-center gap-1 text-sm">
              <input
                type="radio"
                value="no"
                checked={invoiceOption === 'no'}
                onChange={() => setInvoiceOption('no')}
              />
              Sin factura
            </label>
          </div>
        </div>

        {invoiceOption === 'yes' && (
          <div className="mt-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Cédula del Cliente
            </label>
            <input
              type="text"
              value={clientCI}
              onChange={(e) => setClientCI(e.target.value)}
              placeholder="Ej: 1234567"
              className="w-full px-3 py-2 border rounded-md text-sm"
            />
            <div className="flex justify-end mt-2">
              <Button
                variant="outline"
                size="sm"
                onClick={buscarCliente}
                className="flex items-center gap-1"
              >
                Buscar Cliente
              </Button>
            </div>

            {clientInfo && (
              <>
                <p className="text-sm mt-2 text-center text-gray-600">Cliente: {clientInfo.nombre} - CI: {clientInfo.ci}</p>
              </>
            )}

            {showClientForm && (
              <div className="mt-4 space-y-2">
                <input
                  type="text"
                  placeholder="Nombre"
                  className="w-full px-3 py-2 border rounded-md text-sm"
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                />
                <input
                  type="text"
                  placeholder="Apellido"
                  className="w-full px-3 py-2 border rounded-md text-sm"
                  value={apellido}
                  onChange={(e) => setApellido(e.target.value)}
                />
                <Button
                  className="w-full bg-blue-600 text-white"
                  onClick={registrarCliente}
                >
                  Agregar Cliente
                </Button>
              </div>
            )}
          </div>
        )}

        {error && <p className="text-red-500 text-sm mt-2">{error}</p>}

        {!showPropinaPregunta ? (
          <div className="flex justify-end gap-2 mt-6">
            <Button onClick={onClose} variant="outline">Cancelar</Button>
            <Button
              onClick={handleConfirm}
              disabled={!tarjetaProcesada || parseFloat(cashAmount) <= 0}
            >
              Confirmar Pago
            </Button>
          </div>
        ) : (
          <div className="text-center mt-6 space-y-3">
            <p className="text-sm font-medium text-gray-700">¿Desea dejar propina al mozo?</p>
            <div className="flex justify-center gap-4">
              <Button className="bg-green-600 text-white" onClick={handleConfirmPropina}>Sí</Button>
              <Button variant="outline" onClick={handleOmitirPropina}>No</Button>
            </div>
          </div>
        )}
      </div>

      {showTipsModal && (
        <TipsModal
          showTipsModal={showTipsModal}
          setShowTipsModal={setShowTipsModal}
          totalAmount={total}
          currentOrder={venta}
          onConfirm={handleTipsConfirm}
        />
      )}
    </div>
  );
}
